import { z } from 'zod';
import { TimestampSchema } from './common';

export const WebhookSecretSourceSchema = z.enum(['meta-cloud', 'payment', 'meta-ads']);
export type WebhookSecretSource = z.infer<typeof WebhookSecretSourceSchema>;

/**
 * Card-shape pra cada secret per-source. `secretMasked` é os primeiros e
 * últimos chars (`abcd…wxyz`) — plaintext nunca volta em GET.
 */
export const WebhookSecretSchema = z.object({
  source: WebhookSecretSourceSchema,
  hasSecret: z.boolean(),
  secretMasked: z.string().nullable(),
  updatedAt: TimestampSchema.nullable(),
});
export type WebhookSecret = z.infer<typeof WebhookSecretSchema>;

export const WebhookSecretsListResponseSchema = z.object({
  secrets: z.array(WebhookSecretSchema),
});
export type WebhookSecretsListResponse = z.infer<typeof WebhookSecretsListResponseSchema>;

export const SetWebhookSecretInputSchema = z.object({
  secret: z.string().min(16).max(256),
});
export type SetWebhookSecretInput = z.infer<typeof SetWebhookSecretInputSchema>;

export const GenerateWebhookSecretResponseSchema = z.object({
  source: WebhookSecretSourceSchema,
  /** Plaintext do secret recém-gerado — exibido 1x ao operador, depois só mascarado. */
  secret: z.string(),
  secretMasked: z.string(),
});
export type GenerateWebhookSecretResponse = z.infer<typeof GenerateWebhookSecretResponseSchema>;
